import bank from '../../assets/images/bank.svg'
import doctor from '../../assets/images/stethoscope.svg'
import map from '../../assets/images/map.svg'
import microscope from '../../assets/images/microscope.svg'
import medicine from '../../assets/images/medicine.svg'
import cash from '../../assets/images/cash.svg'

export default [
  {
    description: 'Consulta médica presencial e teleconsulta - atendimento online',
    icon: doctor,
    title: 'Saúde'
  },
  {
    description: 'Medicamentos com até 35% de desconto nas redes Droga Raia e Drogasil',
    icon: medicine,
    title: 'Medicamentos'
  },
  {
    description: 'Exames com até 70% de desconto',
    icon: microscope,
    title: 'Exames'
  },
  {
    description: 'Descontos em milhares de lojas e estabelecimentos pelo app',
    icon: bank,
    title: 'Descontos'
  },
  {
    description: 'Cashback em milhares de lojas e estabelecimentos pelo app',
    icon: cash,
    title: 'Dinheiro de volta'
  },
  {
    description: 'Mais de 450 clínicas parceiras de atendimento médico e odontológico',
    icon: map,
    title: 'Clínicas'
  }
]
